import { render } from "./EmptTimeResult.vue?vue&type=template&id=6c65e65d&ts=true"
import script from "./EmptTimeResult.vue?vue&type=script&lang=ts"
export * from "./EmptTimeResult.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1501305b0fb1954c01d0b4f35a9e823f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__